<template>
   <KTCodePreview v-bind:title="'Thông tin phiếu xuất hàng lỗi'"
    > <template v-slot:toolbar
      >
      <div
        v-if="stockSlip.id"
        class="defective-slip-toolbar"
      >
        <EditToggle
          v-model="isEdit"
          id="customSwitch2"
          label="Chỉnh sửa"
        />
        <DefectiveStockSlipExportButton
          :stock-slip-id="stockSlip.id"
          :stock-slip-code="stockSlip.code"
        />
      </div>
       </template
    > <template v-slot:preview
      > <StockSlipSkeleton
        :renderComponent="renderComponent"
        v-if="!renderComponent"
      />
      <div v-if="renderComponent">
         <b-row
          class="mb-5 col-12 mb-1 m-0 p-0"
          v-if="stockSlip.code"
          > <label class="font-weight-bold"
            >Mã phiếu kho: <a class="text-primary">{{ stockSlip.code }}</a></label
          > </b-row
        > <b-row class="mb-5 col-6 mb-1 m-0 p-0"
          > <StockSlipDefective
            :stockSlip="stockSlip"
            :stores="filteredOptions"
            :reasons="filteredReasons"
            @onSelectedSourceWarehouse="onSelectedSourceWarehouse"
            @onInputChangeSourceWarehouse="onInputChangeSourceWarehouse"
            @onSelectedReason="onSelectedReason"
            @onInputChangeReason="onInputChangeReason"
            :editable="isEdit"
          /> </b-row
        > <b-row class="mb-5 col-12 mb-1 m-0 p-0"
          > <StockSlipDefectiveProduct
            :editable="isEdit"
            :productItems="stockSlip.details"
            :storeId="stockSlip.sourceWarehouseId"
            :isSubmitting="isSubmitting"
            :isExport="true"
            ref="stockSlipDefectiveProduct"
          /> </b-row
        >
      </div>
       </template
    > <template v-slot:foot
      > <b-button
        style="font-weight: 600; width: 70px; margin-right: 10px"
        variant="primary"
        size="sm"
        @click="onSubmit"
        :disabled="!isEdit"
        >Lưu</b-button
      > <router-link
        to="/defective-goods-export"
        tag="button"
        > <b-button
          style="margin-left: 10px; font-weight: 600; width: 70px"
          variant="secondary"
          size="sm"
          >Hủy</b-button
        > </router-link
      > </template
    > </KTCodePreview
  >
</template>

<script>
  import apiCommonMixin from '@/view/mixins/api-common.mixins.js'
  import ApiService from '@/core/services/api.service'
  import KTCodePreview from '@/view/content/CodePreview.vue'
  import { makeToastFaile, makeToastSuccess, xoa_dau } from '@/utils/common'
  import { DEFECTIVE_GOODS_EXPORT } from '@/utils/constants'
  import StockSlipSkeleton from '@/view/components/stock-slips/StockSlipSkeleton.vue'
  import StockSlipDefective from '@/view/components/stock-slips/StockSlipDefective.vue'
  import StockSlipDefectiveProduct from '@/view/components/stock-slips/StockSlipDefectiveProduct.vue'
  import EditToggle from '@/view/components/common/EditToggle.vue'
  import DefectiveStockSlipExportButton from '@/view/components/stock-slips/DefectiveStockSlipExportButton.vue'

  export default {
    mixins: [apiCommonMixin],
    data() {
      return {
        stockSlip: {
          id: null,
          code: '',
          type: DEFECTIVE_GOODS_EXPORT,
          sourceWarehouseName: '',
          sourceWarehouseId: null,
          destinationWarehouseName: '',
          destinationWarehouseId: null,
          notes: '',
          relatedStockSlipId: null,
          relatedStockSlipCode: '',
          details: [],
        },
        filteredOptions: [],
        sourceWarehouses: [],
        reasons: [],
        filteredReasons: [],
        isSubmitting: false,
        renderComponent: true,
        isEdit: false,
      }
    },
    components: {
      KTCodePreview,
      StockSlipSkeleton,
      StockSlipDefective,
      StockSlipDefectiveProduct,
      EditToggle,
      DefectiveStockSlipExportButton,
    },
    async created() {
      this.filteredOptions = []
      const { stores, currentStoreId, currentStoreName } = await this.fetchStoreByUser()
      this.stores = stores
      this.fetchReason()
      this.filteredOptions = [...this.stores]
      if (currentStoreId && !this.stockSlip.sourceWarehouseId) {
        this.stockSlip.sourceWarehouseId = currentStoreId
        this.stockSlip.sourceWarehouseName = currentStoreName
      }
      this.stockSlip.id = this.$route.query?.id || null
      if (this.stockSlip.id) {
        await this.getStockSlipByID()
      } else {
        this.isEdit = true
      }
    },
    methods: {
      createStockSlip: async function () {
        const details = this.stockSlip.details.map((element) => {
          const imeis = element.IMEI?.trim() || ''
          return {
            productId: element.productId,
            imeis,
            quantity: element.quantity,
          }
        })
        const payload = {
          sourceWarehouseId: this.stockSlip.sourceWarehouseId,
          description: this.stockSlip.notes,
          stockSlipType: this.stockSlip.type,
          reasonId: this.stockSlip.reasonId,
          details,
        }
        if (!payload.sourceWarehouseId) {
          this.isSubmitting = false
          return makeToastFaile('Vui lòng chọn kho chuyển!')
        }
        if (!payload.reasonId) {
          this.isSubmitting = false
          return makeToastFaile('Vui lòng chọn lý do!')
        }

        if (!payload.details || payload.details.length === 0) {
          this.isSubmitting = false
          return makeToastFaile('Vui lòng chọn sản phẩm!')
        }

        try {
          const url = 'v1/stock-status-transfer/defective-stock-slips'
          const res = await ApiService.post(url, payload).catch((error) => {
            this.isSubmitting = false
            const message = error?.response?.data?.message || 'Lỗi!'
            makeToastFaile(message)
          })
          makeToastSuccess(res.data.message)
          this.$router.push({
            name: 'list-defective-goods-transfer',
          })
        } catch ({ response }) {
          makeToastFaile(response.$error)
        } finally {
          this.isSubmitting = false
        }
      },
      updateStockSlip: async function () {
        const details = this.stockSlip.details.map((element) => {
          const imeis = element.IMEI?.trim() || ''
          return {
            id: element.id,
            productId: element.productId,
            imeis,
            quantity: element.quantity,
          }
        })
        const payload = {
          id: this.stockSlip.id,
          sourceWarehouseId: this.stockSlip.sourceWarehouseId,
          reasonId: this.stockSlip.reasonId,
          description: this.stockSlip.notes,
          details,
        }
        if (!payload.sourceWarehouseId) {
          this.isSubmitting = false
          return makeToastFaile('Vui lòng chọn kho chuyển!')
        }
        if (!payload.reasonId) {
          this.isSubmitting = false
          return makeToastFaile('Vui lòng chọn lý do!')
        }

        if (!payload.details || payload.details.length === 0) {
          this.isSubmitting = false
          return makeToastFaile('Vui lòng chọn sản phẩm!')
        }
        try {
          const res = await ApiService.put(
            'v1/stock-status-transfer/defective-stock-slips',
            payload,
          ).catch((error) => {
            this.isSubmitting = false
            const message = error?.response?.data?.message || 'Lỗi!'
            makeToastFaile(message)
          })
          makeToastSuccess(res.data.message)
          this.$router.push({
            name: 'list-defective-goods-export',
          })
        } catch ({ response }) {
          makeToastFaile(response.$error)
        } finally {
          this.isSubmitting = false
        }
      },
      onSubmit() {
        if (this.isSubmitting) return
        this.isSubmitting = true
        if (!this.stockSlip.id) {
          this.createStockSlip()
          return
        }
        this.updateStockSlip()
      },
      onSelectedSourceWarehouse(option) {
        this.stockSlip.sourceWarehouseName = option.item.name
        this.stockSlip.sourceWarehouseId = option.item.id
      },
      onInputChangeSourceWarehouse(text) {
        this.stockSlip.sourceWarehouseName = text
        const filteredData = this.stores
          .filter((item) => {
            return (
              xoa_dau(item.name).toLowerCase().indexOf(text.toLowerCase()) > -1 ||
              item.shortName.toLowerCase().indexOf(text.toLowerCase()) > -1
            )
          })
          .slice(0, 10)
        this.filteredOptions = [...filteredData]
      },
      onSelectedReason(option) {
        this.stockSlip.reasonName = option.item.name
        this.stockSlip.reasonId = option.item.id
      },
      onInputChangeReason(text) {
        this.stockSlip.reasonName = text
        const filteredData = this.reasons
          .filter((item) => {
            return xoa_dau(item.name).toLowerCase().indexOf(text.toLowerCase()) > -1
          })
          .slice(0, 10)
        this.filteredReasons = [...filteredData]
      },
      getStockSlipByID: async function () {
        this.renderComponent = false
        ApiService.get(`v1/stock-slips/${this.stockSlip.id}`).then((data) => {
          const stockSlipData = data.data.data
          this.stockSlip.code = stockSlipData.code
          this.stockSlip.type = stockSlipData.type
          this.stockSlip.sourceWarehouseId = stockSlipData.storeId
          this.stockSlip.sourceWarehouseName = stockSlipData.storeName
          this.stockSlip.reasonId = stockSlipData.reasonId
          this.stockSlip.reasonName = stockSlipData.reasonName
          this.stockSlip.notes = stockSlipData.description
          this.stockSlip.details = stockSlipData.details.map((detail, index) => {
            return {
              ...detail,
              stt: index + 1,
              productPriceMask: detail.unitPrice,
              IMEI: detail.productImei || '',
            }
          })
          this.renderComponent = true
        })
      },
      fetchReason: async function () {
        this.filteredOptions = []
        ApiService.get('v1/stock-status-transfer/defective-export-reasons').then((response) => {
          this.reasons = response.data.data
          this.filteredReasons = [...this.reasons]
        })
      },
    },
  }
</script>

<style scoped>
.defective-slip-toolbar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-left: 1.5rem;
  margin-bottom: 1.5rem;
}

.defective-slip-toolbar >>> .custom-switch {
  margin-bottom: 0;
  padding-left: 2.25rem;
}
</style>

